import { cartEventEmitter as N, useCartState as ie } from "@made-people/grease-cart";
import { getProductAttribute as C, productEventEmitter as k, useMaybeProductBase as ae } from "@made-people/grease-product";
import { orderEventEmitter as V } from "@made-people/grease-order";
import { useEffectOnce as se, once as ne } from "@made-people/react-use-effect-once";
import { createContext as B, useContext as M, useState as ce, useMemo as S, useCallback as le, useEffect as ue } from "react";
import I, { z as o } from "zod";
import { jsx as P, Fragment as de, jsxs as ge } from "react/jsx-runtime";
import { useGlobalSearchSettings as me, emptySearchResult as y, searchResultQueryMethodsContext as fe, SearchResultProvider as he, useFacetGrouping as pe, useCurrentPaginationPage as ye, CachedSearchResultsProvider as be, AutoCompleteProvider as Pe } from "@made-people/grease-search";
import { withManagedProps as K } from "@made-people/managed-props";
import { withZod as Q } from "@made-people/react-prop-guard";
import { crc32 as Ae } from "@made-people/functions-crc32";
const W = B(void 0), z = B(
  void 0
), R = () => {
  const e = M(W);
  if (!e)
    throw new Error(
      "useAlgoliaSearchClient must be used within an AlgoliaProvider"
    );
  return e;
}, v = () => {
  const e = M(z);
  if (!e)
    throw new Error("useAlgoliaConfig must be used within an AlgoliaProvider");
  return e;
}, D = "algolia_object_id", _ = (e) => {
  var r;
  return (r = C(
    e.attributes,
    D,
    I.string()
  )) == null ? void 0 : r.value;
}, Se = () => {
  const e = R(), r = v();
  return async (i, t, a, s) => {
    var n, c, l, d;
    try {
      const f = await e();
      if (!f) {
        console.warn("Algolia client not configured, skipping insights event");
        return;
      }
      const { indexName: g, insightsClient: h } = f, u = (n = C(
        a.attributes,
        D,
        I.string()
      )) == null ? void 0 : n.value;
      if (!u) {
        console.warn(
          "Algolia objectID not found in product attributes, skipping insights event"
        );
        return;
      }
      if (!g) {
        console.warn("Algolia index name not found, skipping insights event");
        return;
      }
      const p = (c = C(
        a.attributes,
        "algolia_query_id",
        I.string()
      )) == null ? void 0 : c.value, b = (l = C(
        a.attributes,
        "algolia_position",
        I.number()
      )) == null ? void 0 : l.value, m = {
        eventType: i,
        eventName: t,
        index: g,
        objectIDs: [u],
        userToken: ((d = r.insights) == null ? void 0 : d.userToken) ?? "",
        // Add eventSubtype for conversion events
        ...s && { eventSubtype: s },
        // Add queryID for search events
        ...p && { queryID: p },
        // Add positions array for click events when position is available
        ...i === "click" && b !== void 0 && { positions: [b] }
      };
      await h.pushEvents({
        events: [m]
      });
    } catch (f) {
      console.error(
        `Error sending ${i} insights event to Algolia`,
        f
      );
    }
  };
}, ve = () => {
  const e = Se(), r = async (t) => {
    t.context.type === "pdp" ? await e("view", "PDP Viewed", t.productData.base) : t.context.type === "plp" && await e("view", "PLP Viewed", t.productData.base);
  }, i = async (t) => {
    var a;
    if ((a = t.order) != null && a.items)
      for (const s of t.order.items)
        s.type === "product" && await e(
          "conversion",
          "Product Purchased",
          s.product.base,
          "purchase"
        );
  };
  return se(() => (k.on("productClicked", async (t) => {
    await e("click", "Product Clicked", t.productData.base);
  }), k.on("productViewed", async (t) => {
    await r(t);
  }), N.on("addToCart", async (t) => {
    await e(
      "conversion",
      "Product Added to Cart",
      t.payload.product,
      "addToCart"
    );
  }), V.on("orderPlaced", async (t) => {
    await i(t);
  }), () => {
    k.off("productClicked", async (t) => {
      await e(
        "click",
        "Product Clicked",
        t.productData.base
      );
    }), k.off("productViewed", async (t) => {
      await r(t);
    }), N.off("addToCart", async (t) => {
      await e(
        "conversion",
        "Product Added to Cart",
        t.payload.product,
        "addToCart"
      );
    }), V.off("orderPlaced", async (t) => {
      await i(t);
    });
  })), null;
}, we = o.object({
  periodDays: o.number(),
  price: o.string(),
  priceAsNumber: o.number(),
  priceBeforeDiscount: o.string(),
  priceBeforeDiscountAsNumber: o.number()
}), q = o.union([
  o.number(),
  o.literal("infinite")
]), Ct = o.array(o.never()).length(0), ke = o.object({
  category: o.number(),
  primary: o.boolean(),
  sortOrder: o.number(),
  name: o.string(),
  uri: o.string(),
  uriForProduct: o.string()
}), Ce = o.object({
  price: o.string(),
  priceBeforeDiscount: o.string(),
  priceReduction: o.string(),
  priceAsNumber: o.number(),
  priceBeforeDiscountAsNumber: o.number(),
  priceReductionAsNumber: o.number(),
  discountPercent: o.number(),
  showAsOnSale: o.boolean(),
  newProduct: o.boolean(),
  lowestPrice: o.array(we).optional()
}), Ie = o.object({
  stockOfAllItems: q,
  pricesByPricelist: o.record(Ce).optional()
}), U = o.object({
  minimum: o.number(),
  maximum: o.number()
}), De = o.object({
  product: o.string(),
  measureQuantity: o.number(),
  quantity: U
}), Ee = o.object({
  priceCalculation: o.string().optional(),
  measureQuantity: U,
  products: o.array(De)
}).passthrough(), Fe = o.object({
  type: o.string(),
  priceType: o.string(),
  priceOfItems: o.record(o.number()),
  discount: o.record(o.number())
}), Oe = o.object({
  item: o.string(),
  name: o.string(),
  ean: o.string(),
  sku: o.string(),
  stockByMarket: o.record(q),
  stockByWarehouse: o.record(q).optional()
}).passthrough(), je = o.object({
  product: o.string(),
  name: o.string(),
  uri: o.string(),
  preview: o.boolean().optional(),
  sku: o.string(),
  productSku: o.string(),
  brand: o.string(),
  brandName: o.string(),
  collection: o.string().nullable(),
  collectionName: o.string().nullable(),
  silkProduct: o.string(),
  silkProductName: o.string(),
  silkVariant: o.string(),
  silkVariantName: o.string(),
  folderName: o.string().nullable(),
  foldersName: o.string(),
  variantName: o.string(),
  primaryVariant: o.boolean(),
  excerpt: o.string(),
  description: o.string(),
  metaTitle: o.string(),
  metaDescription: o.string(),
  metaKeywords: o.string(),
  weight: o.number(),
  weightUnit: o.string(),
  stockUnit: o.string(),
  supplierName: o.string().nullish(),
  createdAt: o.string(),
  measurementCart: o.string().nullish(),
  measurementChartRows: o.record(o.any()),
  harmCode: o.string(),
  harmCodeDescription: o.string(),
  countryOfOrigin: o.string(),
  countryOfOriginName: o.string(),
  color_swatch: o.object({
    description: o.string(),
    image: o.object({
      type: o.string(),
      url: o.string(),
      width: o.string(),
      height: o.string(),
      mimeType: o.string()
    }).optional()
  }).optional(),
  markets: o.record(Ie),
  items: o.union([
    o.record(Oe),
    o.array(o.never()).length(0)
  ]),
  canonicalCategory: o.number(),
  canonicalUri: o.string(),
  categories: o.array(ke),
  media: o.array(
    o.object({
      type: o.string(),
      sources: o.record(
        o.object({
          url: o.string(),
          width: o.number(),
          height: o.number(),
          mimeType: o.string()
        })
      )
    })
  ),
  localized: o.record(o.any()).optional(),
  variant_canonical: o.string().optional(),
  relatedProducts: o.array(
    o.object({
      product: o.string(),
      relation: o.string()
    })
  ).optional(),
  bundle: Ee.optional(),
  bundleInfo: Fe.optional()
}).passthrough(), J = o.object({
  objectID: o.string(),
  algoliaTypeID: o.literal("product"),
  gearsLoaderType: o.literal("centra-shop-api-product-loader")
}), qe = je.merge(J).passthrough(), T = (e) => J.safeParse(e).success, Re = [
  "related-products",
  "bought-together",
  "looking-similar"
], Te = () => {
  const e = v(), r = R(), i = me();
  return async (t) => {
    var d, f, g, h;
    const a = t.maxRecommendations ?? i.defaultItemsPerPage, s = await r();
    if (!s)
      return console.error("Algolia: Client data not available"), y;
    const { indexName: n, recommendClient: c } = s, l = t.objectID;
    if (!l && Re.includes(t.model))
      return console.error(
        `Algolia: objectID is required for recommendation model: ${t.model}`
      ), y;
    try {
      let u;
      switch (t.model) {
        case "related-products":
          if (!l)
            return y;
          u = await c.getRelatedProducts([
            {
              indexName: n,
              objectID: l,
              maxRecommendations: a,
              queryParameters: t.queryParameters,
              fallbackParameters: t.fallbackParameters
            }
          ]);
          break;
        case "bought-together":
          if (!l)
            return y;
          u = await c.getFrequentlyBoughtTogether([
            {
              indexName: n,
              objectID: l,
              maxRecommendations: a,
              queryParameters: t.queryParameters
            }
          ]);
          break;
        case "trending-items":
          u = await c.getTrendingItems([
            {
              indexName: n,
              maxRecommendations: a,
              queryParameters: t.queryParameters,
              fallbackParameters: t.fallbackParameters
            }
          ]);
          break;
        case "trending-facets":
          u = await c.getTrendingFacets([
            {
              indexName: n,
              facetName: ((f = (d = t.queryParameters) == null ? void 0 : d.facetFilters) == null ? void 0 : f[0]) || "",
              maxRecommendations: a
            }
          ]);
          break;
        case "looking-similar":
          if (!l)
            return y;
          u = await c.getLookingSimilar([
            {
              indexName: n,
              objectID: l,
              maxRecommendations: a,
              queryParameters: t.queryParameters,
              fallbackParameters: t.fallbackParameters
            }
          ]);
          break;
        default:
          return console.error(
            `Algolia: Unknown recommendation model: ${t.model}`
          ), y;
      }
      if (!((h = (g = u == null ? void 0 : u.results) == null ? void 0 : g[0]) != null && h.hits))
        return y;
      const b = u.results[0].hits.map((m) => {
        if (T(m)) {
          const A = e.mappers.centraShopProduct(m);
          return A ? {
            type: "product",
            product: A
          } : void 0;
        }
      }).filter((m) => m !== void 0);
      return {
        items: b,
        meta: {
          totalItems: b.length,
          itemsPerPage: b.length,
          currentPage: 1,
          totalPages: 1
        },
        facets: [],
        // Not supported for recommendations by Algolia
        sort: []
        // Not supported for recommendations by Algolia
      };
    } catch (u) {
      return console.error("Algolia: Error fetching recommendations", u), y;
    }
  };
}, xe = o.object({
  model: o.enum([
    "related-products",
    "bought-together",
    "trending-items",
    "trending-facets",
    "looking-similar"
  ]),
  objectID: o.string().optional(),
  maxRecommendations: o.number().optional(),
  queryParameters: o.object({
    filters: o.string().optional(),
    facetFilters: o.array(o.string()).optional(),
    numericFilters: o.array(o.string()).optional()
  }).optional(),
  fallbackParameters: o.object({
    filters: o.string().optional(),
    facetFilters: o.array(o.string()).optional()
  }).optional(),
  children: o.any()
}), $e = K(
  "AlgoliaRecommendations",
  Q(
    xe,
    (e) => {
      const { cart: r } = ie(), i = ae(), [t, a] = ce(
        void 0
      ), s = S(() => {
        var h;
        if (e.objectID)
          return e.objectID;
        if (i) {
          const u = _(i);
          if (u)
            return u;
          if (i.productId)
            return `product-${i.productId}`;
        }
        if ((h = r == null ? void 0 : r.items) != null && h.length) {
          const u = r.items[0];
          if (u) {
            const p = _(u.product.base);
            if (p)
              return p;
            if (u.product.base.productId)
              return `product-${u.product.base.productId}`;
          }
        }
      }, [e.objectID, i, r == null ? void 0 : r.items]), n = S(
        () => ({
          model: e.model,
          objectID: s,
          maxRecommendations: e.maxRecommendations,
          queryParameters: e.queryParameters,
          fallbackParameters: e.fallbackParameters
        }),
        [
          e.model,
          s,
          e.maxRecommendations,
          e.queryParameters,
          e.fallbackParameters
        ]
      ), c = async () => y, l = Te(), d = S(
        () => Ae(JSON.stringify(n)),
        [n]
      ), f = le(
        ne(async () => {
          const h = await l(n);
          a(h);
        }),
        [d]
      );
      ue(() => {
        f();
      }, [d]);
      const g = {
        loadPage: () => Promise.resolve([]),
        setFacets: c,
        reset: async () => await l(n),
        setSortOrder: c
      };
      return !t || t.items.length === 0 ? null : /* @__PURE__ */ P(fe.Provider, { value: g, children: /* @__PURE__ */ P(he, { result: t, children: e.children }) });
    }
  )
);
$e.displayName = "AlgoliaRecommendations";
const Ne = o.object({
  algoliaRequestOptions: o.custom().optional(),
  algoliaTypeId: o.string().default("product"),
  searchQuery: o.string().default(""),
  disjunctiveFacets: o.array(o.string()).optional(),
  facetGroupConfigs: o.custom().optional()
}), Ve = o.object({
  payload: Ne,
  children: o.custom()
}), _e = (e, r) => {
  if (!Array.isArray(e))
    return [];
  const i = [];
  return e.forEach((t) => {
    typeof t == "string" ? t.startsWith(`${r}:`) && i.push(t) : Array.isArray(t) && t.forEach((a) => {
      typeof a == "string" && a.startsWith(`${r}:`) && i.push(a);
    });
  }), i;
}, Le = (e, r, i, t) => Object.entries(e).map(([a, s]) => {
  var c;
  let n;
  return t != null && t[a] ? n = t[a].map((l) => `${a}:${l}`) : n = _e(
    (c = r.algoliaRequestOptions) == null ? void 0 : c.facetFilters,
    a
  ), {
    name: a,
    id: a,
    type: "checkbox",
    selectedCount: n.length,
    values: Object.entries(s).map(
      ([l, d]) => i.algoliaFacetToGreaseFacetValue(a, l, d, n)
    )
  };
}), Ge = (e, r) => e.filter(
  (t) => r.includes(t.id)
).sort((t, a) => {
  const s = r.indexOf(t.id), n = r.indexOf(a.id);
  return (s === -1 ? 1 / 0 : s) - (n === -1 ? 1 / 0 : n);
}), Be = (e, r, i = [], t, a) => {
  if (!e)
    return [];
  const s = Le(
    e,
    r,
    t,
    a
  );
  return Ge(s, i);
}, x = "x", H = (e, r = x) => e.includes(r) ? e.split(r) : [], Me = (e) => {
  const r = {}, i = {};
  return e.facetIds.forEach((t) => {
    r[t] = {}, i[t] = /* @__PURE__ */ new Set();
  }), { individualFacets: r, selectedValues: i };
}, Ke = (e, r, i) => {
  e.forEach((t) => {
    H(
      t,
      r.delimiter ?? x
    ).forEach((s, n) => {
      var l;
      const c = r.facetOrder[n];
      c && s && ((l = i[c]) == null || l.add(s));
    });
  });
}, Qe = (e, r) => {
  Object.entries(e).forEach(([i, t]) => {
    t.forEach((a) => {
      var s;
      return (s = r[i]) == null ? void 0 : s.add(a);
    });
  });
}, We = (e, r, i) => {
  Object.entries(e).forEach(([t, a]) => {
    H(
      t,
      r.delimiter ?? x
    ).forEach((n, c) => {
      const l = r.facetOrder[c];
      l && n && i[l] && (i[l][n] = (i[l][n] || 0) + a);
    });
  });
}, ze = (e, r, i) => {
  const t = { ...e }, a = {};
  return i.filter(
    (n) => n.relationship === "and" && n.compositeField
  ).forEach((n) => {
    var h;
    const c = n.compositeField, l = e[c.fieldName];
    if (!l)
      return;
    const d = Ue(
      n,
      (h = r.algoliaRequestOptions) == null ? void 0 : h.facetFilters
    );
    delete t[c.fieldName];
    const { individualFacets: f, selectedValues: g } = Me(n);
    Ke(
      d.composite,
      c,
      g
    ), Qe(d.individual, g), We(
      l,
      c,
      f
    ), Object.entries(f).forEach(([u, p]) => {
      if (Object.keys(p).length > 0)
        if (!t[u])
          t[u] = p, a[u] = Array.from(g[u] || []);
        else {
          const b = a[u] || [], m = Array.from(g[u] || []);
          a[u] = [
            .../* @__PURE__ */ new Set([...b, ...m])
          ];
        }
    });
  }), {
    facets: t,
    selections: a
  };
}, Ue = (e, r) => {
  const i = {
    composite: [],
    individual: {}
  };
  if (e.facetIds.forEach((a) => {
    i.individual[a] = [];
  }), !r)
    return i;
  const t = (a) => {
    var s;
    if ((s = e.compositeField) != null && s.fieldName && a.startsWith(`${e.compositeField.fieldName}:`)) {
      const n = a.split(":")[1];
      n && i.composite.push(n);
    }
    e.facetIds.forEach((n) => {
      var c;
      if (a.startsWith(`${n}:`)) {
        const l = a.split(":")[1];
        l && ((c = i.individual[n]) == null || c.push(l));
      }
    });
  };
  return typeof r == "string" ? t(r) : Array.isArray(r) && r.forEach((a) => {
    typeof a == "string" ? t(a) : Array.isArray(a) && a.forEach((s) => {
      typeof s == "string" && t(s);
    });
  }), i;
}, Je = (e, r, i, t) => {
  var l, d, f;
  if (!(r != null && r.hits))
    return y;
  const a = r.hits.map((g, h) => {
    if (T(g)) {
      const u = i.centraShopProduct(g);
      return u ? {
        type: "product",
        product: {
          ...u,
          base: {
            ...u.base,
            attributes: [
              ...u.base.attributes,
              {
                attributeKey: "algolia_query_id",
                attributeLabel: "algolia_query_id",
                value: r.queryID,
                valueLabel: r.queryID || ""
              },
              {
                attributeKey: "algolia_position",
                attributeLabel: "algolia_position",
                value: h,
                valueLabel: h.toString()
              }
            ]
          }
        }
      } : void 0;
    }
  }).filter((g) => g !== void 0);
  let s = r.facets, n;
  if (t && r.facets) {
    const g = ze(
      r.facets,
      e,
      t
    );
    s = g.facets, n = g.selections;
  }
  const c = Be(
    s,
    e,
    (f = (d = (l = r.renderingContent) == null ? void 0 : l.facetOrdering) == null ? void 0 : d.facets) == null ? void 0 : f.order,
    i,
    n
  );
  return {
    items: a,
    meta: {
      totalItems: r.nbHits,
      itemsPerPage: r.hitsPerPage,
      currentPage: r.page,
      totalPages: r.nbPages
    },
    facets: c,
    sort: []
    // Not yet supported
  };
}, Y = (e, r = []) => {
  const i = /* @__PURE__ */ new Set([e]);
  for (const t of r)
    !t.compositeField || !Array.isArray(t.facetIds) || t.facetIds.includes(e) && (i.add(t.compositeField.fieldName), t.facetIds.forEach((a) => i.add(a)));
  return Array.from(i);
}, He = (e, r, i = []) => {
  if (!Array.isArray(e))
    return [];
  const t = Y(r, i), a = [];
  return e.forEach((s) => {
    if (typeof s == "string")
      t.some((n) => s.startsWith(`${n}:`)) && a.push(s);
    else if (Array.isArray(s)) {
      const n = s.filter(
        (c) => typeof c == "string" && t.some((l) => c.startsWith(`${l}:`))
      );
      n.length > 0 && a.push(n);
    }
  }), a;
}, Ye = (e, r, i = []) => {
  if (!Array.isArray(e))
    return [];
  const t = Y(r, i), a = [];
  return e.forEach((s) => {
    if (typeof s == "string")
      t.some((n) => s.startsWith(`${n}:`)) || a.push(s);
    else if (Array.isArray(s)) {
      const n = s.filter(
        (c) => !(typeof c == "string" && t.some((l) => c.startsWith(`${l}:`)))
      );
      n.length > 0 && a.push(n);
    }
  }), a;
}, Ze = (e) => {
  if (!e)
    return [];
  const r = [], i = (t) => {
    const a = t.indexOf(":");
    a > 0 && r.push(t.substring(0, a));
  };
  return typeof e == "string" ? i(e) : Array.isArray(e) && e.forEach((t) => {
    typeof t == "string" ? i(t) : Array.isArray(t) && t.forEach((a) => {
      typeof a == "string" && i(a);
    });
  }), [...new Set(r)];
}, Xe = async (e, r, i, t = []) => {
  var h, u, p, b;
  const a = i.disjunctiveFacets || [], s = (h = i.algoliaRequestOptions) == null ? void 0 : h.facetFilters, n = e.initIndex(r);
  if (!s || Array.isArray(s) && s.length === 0) {
    const m = await n.search(i.searchQuery, {
      ...i.algoliaRequestOptions,
      clickAnalytics: !0
      // Enable queryID for insights tracking
    });
    return a.length === 0 || a.length === 1 && a[0] === "*", m;
  }
  if (a.length === 0)
    return await n.search(i.searchQuery, {
      ...i.algoliaRequestOptions,
      clickAnalytics: !0
      // Enable queryID for insights tracking
    });
  let c = a.filter((m) => m !== "*");
  if (a.includes("*")) {
    const { facetFilters: m, ...A } = i.algoliaRequestOptions || {}, O = await n.search(i.searchQuery, {
      ...A,
      hitsPerPage: 0,
      page: 0,
      clickAnalytics: !0
      // Enable queryID for insights tracking
    }), w = ((b = (p = (u = O.renderingContent) == null ? void 0 : u.facetOrdering) == null ? void 0 : p.facets) == null ? void 0 : b.order) || Object.keys(O.facets || {});
    c = [
      .../* @__PURE__ */ new Set([...c, ...w])
    ];
    const re = Ze(s);
    if (c = [
      .../* @__PURE__ */ new Set([...c, ...re])
    ], t) {
      const oe = t.flatMap(
        ($) => $.compositeField ? $.facetIds : []
      );
      c = [
        .../* @__PURE__ */ new Set([...c, ...oe])
      ];
    }
  }
  const l = a.includes("*") ? c : c.filter(
    (m) => He(s, m, t).length > 0
  ), d = [];
  d.push({
    indexName: r,
    params: {
      query: i.searchQuery,
      ...i.algoliaRequestOptions,
      clickAnalytics: !0
      // Enable queryID for insights tracking
    }
  }), l.forEach((m) => {
    d.push({
      indexName: r,
      params: {
        query: i.searchQuery,
        ...i.algoliaRequestOptions,
        // Remove filters for this specific facet AND related fields to get all its values
        facetFilters: Ye(
          s,
          m,
          t
        ),
        // Only fetch facets, not hits
        hitsPerPage: 0,
        page: 0,
        // Request the specific facet
        facets: [m],
        clickAnalytics: !0
        // Enable queryID for insights tracking
      }
    });
  });
  const f = await e.search(d), g = f.results[0];
  return l.length > 0 && (g.facets || (g.facets = {}), l.forEach((m, A) => {
    var w;
    const j = (w = f.results[A + 1].facets) == null ? void 0 : w[m];
    j && (g.facets[m] = j);
  })), g;
}, Z = () => {
  const e = R();
  return async (r) => {
    const i = await e();
    if (i)
      return await Xe(
        i.searchClient,
        i.indexName,
        r,
        r.facetGroupConfigs
      );
  };
}, F = () => {
  const e = v(), r = Z(), i = pe(), t = ye({
    zeroIndexed: !0
  }), a = S(() => (i == null ? void 0 : i()) || void 0, [i]);
  return async (s) => {
    var d;
    const n = ((d = s.algoliaRequestOptions) == null ? void 0 : d.page) ?? t, c = await r({
      ...s,
      algoliaRequestOptions: {
        ...s.algoliaRequestOptions,
        facets: ["*"],
        // Fetch all facets
        page: n,
        clickAnalytics: !0
        // Enable queryID for insights tracking
      },
      facetGroupConfigs: s.facetGroupConfigs ?? a
    });
    if (!c)
      return y;
    const l = s.algoliaTypeId;
    switch (l) {
      case "product":
        return Je(
          s,
          c,
          e.mappers,
          s.facetGroupConfigs ?? a
        );
      default:
        throw new Error(`No mapper found for type id "${l}"`);
    }
  };
}, X = (e) => {
  if (e.length === 0)
    return [];
  if (e.length === 1) {
    const s = e[0];
    return s ? s.map((n) => [n]) : [];
  }
  const [r, ...i] = e;
  if (!r)
    return [];
  const t = X(i), a = [];
  for (const s of r)
    for (const n of t)
      a.push([s, ...n]);
  return a;
}, et = (e, r) => {
  const i = r.facetOrder.map(
    (s) => e[s] || []
  );
  return i.every(
    (s) => s.length > 0
  ) ? X(i).map((s) => {
    try {
      const n = r.valueFormatter(...s);
      return `${r.fieldName}:${n}`;
    } catch {
      return null;
    }
  }).filter((s) => s !== null) : [];
}, ee = (e, r) => {
  const i = [];
  return e.forEach((t) => {
    if (t.type === "group")
      if (t.relationship === "and")
        if (t.compositeField) {
          const a = {};
          t.children.forEach((n) => {
            if (n.type === "checkbox") {
              const c = n.values.filter((l) => l.selected).map((l) => r ? r(n.id, l.id) : l.id);
              c.length > 0 && (a[n.id] = c);
            }
          });
          const s = Object.keys(a).length;
          if (s > 1) {
            const n = et(
              a,
              t.compositeField
            );
            n.length > 0 && i.push(n);
          } else
            s === 1 && t.children.forEach((n) => {
              if (n.type === "checkbox") {
                const c = n.values.filter(
                  (l) => l.selected
                );
                if (c.length > 0) {
                  const l = c.map((d) => {
                    const f = r ? r(n.id, d.id) : d.id;
                    return `${n.id}:${f}`;
                  });
                  i.push(l);
                }
              }
            });
        } else
          t.children.forEach((a) => {
            if (a.type === "checkbox") {
              const s = a.values.filter(
                (n) => n.selected
              );
              if (s.length > 0) {
                const n = s.map((c) => {
                  const l = r ? r(a.id, c.id) : c.id;
                  return `${a.id}:${l}`;
                });
                i.push(n);
              }
            }
          });
      else {
        const a = [];
        t.children.forEach((s) => {
          s.type === "checkbox" && s.values.filter(
            (c) => c.selected
          ).forEach((c) => {
            const l = r ? r(s.id, c.id) : c.id;
            a.push(`${s.id}:${l}`);
          });
        }), a.length > 0 && i.push(a);
      }
    else if (t.type === "checkbox") {
      const a = t.values.filter((s) => s.selected);
      if (a.length > 0) {
        const s = a.map((n) => {
          const c = r ? r(t.id, n.id) : n.id;
          return `${t.id}:${c}`;
        });
        i.push(s);
      }
    }
  }), i;
}, tt = (e) => {
  const r = F(), i = v();
  return async (t, a) => {
    var c;
    const s = {
      ...e,
      algoliaRequestOptions: {
        ...e.algoliaRequestOptions,
        facetFilters: [
          ...((c = e.algoliaRequestOptions) == null ? void 0 : c.facetFilters) || [],
          ...ee(
            (a == null ? void 0 : a.facets) || [],
            i.mappers.resolveFacetValueForFilter
          )
        ],
        page: t - 1
        // Algolia starts counting pages from 0
      }
    };
    return (await r(s)).items;
  };
}, rt = (e) => {
  const r = F(), i = v();
  return async (t) => {
    var s;
    const a = {
      ...e,
      algoliaRequestOptions: {
        ...e.algoliaRequestOptions,
        facetFilters: [
          ...((s = e.algoliaRequestOptions) == null ? void 0 : s.facetFilters) || [],
          ...ee(
            t,
            i.mappers.resolveFacetValueForFilter
          )
        ],
        offset: 0
        // Always reset pagination when changing facets
      }
    };
    return await r(a);
  };
}, It = K(
  "AlgoliaSearchResultsProvider",
  Q(Ve, (e) => {
    const r = F(), i = tt(e.payload), t = rt(e.payload), a = S(
      () => ({
        payload: e.payload,
        algoliaTypeId: e.payload.algoliaTypeId
      }),
      [e.payload]
    ), s = S(
      () => ({
        fetchSearchResult: async () => await r(e.payload),
        loadPage: i,
        setFacets: t,
        setSortOrder: async () => Promise.resolve(y)
      }),
      [r, e.payload, i, t]
    );
    return /* @__PURE__ */ P(de, { children: e.payload.algoliaTypeId === "product" && /* @__PURE__ */ P(
      be,
      {
        queryParams: a,
        searchMethods: s,
        children: e.children
      }
    ) });
  })
);
class ot {
  constructor(r, i) {
    this.algoliaSearch = r, this.algoliaConfig = i, this.search = async (t) => {
      const a = {
        productSuggestions: []
      };
      try {
        const s = await this.algoliaSearch({
          algoliaTypeId: "product",
          searchQuery: t.searchQuery,
          algoliaRequestOptions: {
            hitsPerPage: t.limit,
            clickAnalytics: !0
            // Enable queryID for insights tracking
          }
        });
        return s ? {
          productSuggestions: this.mapProducts(
            s.hits
          )
        } : a;
      } catch (s) {
        return console.error("Error in algolia auto-complete search:", s), a;
      }
    };
  }
  mapProducts(r = []) {
    return r.filter(T).map(this.algoliaConfig.mappers.centraShopProduct).filter((i) => i !== void 0);
  }
}
const Dt = (e) => {
  const r = Z(), i = v();
  return /* @__PURE__ */ P(
    Pe,
    {
      autoCompleteClient: new ot(r, i),
      children: e.children
    }
  );
}, it = (e) => {
  var r;
  return /* @__PURE__ */ P(z.Provider, { value: e.algoliaConfig, children: /* @__PURE__ */ ge(W.Provider, { value: e.algoliaClientDataGetter, children: [
    ((r = e.algoliaConfig.insights) == null ? void 0 : r.userToken) && /* @__PURE__ */ P(ve, {}),
    e.children
  ] }) });
};
it.displayName = "AlgoliaProvider";
const Et = (e) => {
  const r = F();
  return async () => await r(e);
};
function Ft(e, r, i) {
  try {
    const t = Object.values(e.items);
    if (t.length === 1) {
      const s = t[0];
      if (!s)
        throw Error(
          `Product "${e.product}" has no items, cannot create product`
        );
      return {
        base: L(e, i),
        dataModel: "simple",
        isBundle: e.bundleInfo !== void 0,
        siblingProducts: [],
        itemId: s.item,
        ...te(
          e,
          s,
          r
        )
      };
    }
    return {
      dataModel: "with_variants",
      base: L(e, i),
      siblingProducts: [],
      variants: t.map(
        (s) => ut(
          e,
          s,
          r,
          i
        )
      )
    };
  } catch (t) {
    console.error(`Error while converting product "${e.product}"`, t);
    return;
  }
}
function L(e, r) {
  return {
    productId: e.product,
    productKey: e.product,
    slug: e.uri,
    discontinued: !1,
    content: at(
      e,
      r
    ),
    attributes: mt(e),
    categories: nt(e)
  };
}
function at(e, r) {
  return {
    name: e.name,
    description: e.description,
    shortDescription: e.excerpt,
    media: st(
      e,
      r
    ),
    badges: []
  };
}
function st(e, r) {
  const i = e.media;
  return i.length ? i.map((a) => {
    var n;
    const s = (n = a.sources[r.productImageKey]) == null ? void 0 : n.url;
    if (s)
      return {
        type: "image",
        src: s,
        alt: e.name
      };
  }).filter((a) => i !== void 0) : (console.error(`Product "${e.product}" has no media"`), []);
}
function nt(e) {
  return Object.values(e.categories).map((i) => ({
    categoryId: i.category.toString(),
    // categoryKey: category.category needed?
    name: i.name,
    slug: i.uri
  }));
}
function ct(e, r) {
  const i = e.stockByMarket[r];
  return i === void 0 ? (console.warn("Stock not found for market", r), 0) : typeof i == "string" && i === "infinite" ? 999999 : i ?? 0;
}
function lt(e, r) {
  var a;
  const i = e[r.market];
  if (!i)
    throw Error(
      `AlgoliaShopProduct is missing market data for ${r.market}`
    );
  const t = (a = i == null ? void 0 : i.pricesByPricelist) == null ? void 0 : a[r.pricelist];
  if (!t)
    throw Error(
      `AlgoliaShopProduct is missing pricelist data for ${r.pricelist}`
    );
  return {
    price: {
      formatted: t.price,
      number: t.priceAsNumber
    },
    priceWithoutDiscount: {
      formatted: t.priceBeforeDiscount,
      number: t.priceBeforeDiscountAsNumber
    },
    // TODO: lowest prices implementation below
    previouslyDiscountedPrices: []
    // previouslyDiscountedPrices: {
    //   date: string;
    //   price: string;
    //   priceNumber: number;
    //   priceWithoutDiscount: string;
    //   priceWithoutDiscountNumber: number;
    // }[];
    // TODO: discount info below
    // discountInfo?: {
    //   percent: number;
    // } | undefined;
  };
}
function te(e, r, i) {
  const t = ct(r, i.market), a = t > 0, s = lt(e.markets, i);
  return {
    sku: r.sku,
    inventory: {
      quantity: t,
      inStock: a,
      warehouseId: "1"
    },
    additionalInventory: [],
    priceInfo: s
  };
}
function ut(e, r, i, t) {
  return {
    dimensions: dt(r, t),
    label: r.name,
    mainProductId: e.product,
    mainProductKey: e.product,
    variantId: r.item,
    variantKey: r.item,
    ...te(
      e,
      r,
      i
    )
  };
}
const dt = (e, r) => {
  const i = r.itemIdDimensionParser;
  if (!i)
    return [G(e)];
  const t = e.name.split(i.delimiter);
  return t.length === 1 ? [G(e)] : t.map(
    (a, s) => gt(a, i.dimensionInfo[s])
  );
}, E = {
  key: "size",
  label: "Item_Dimension_Size"
}, G = (e) => ({
  value: e.name,
  valueLabel: e.name,
  dimensionKey: E.key,
  dimensionLabel: E.label
}), gt = (e, r) => ({
  value: e,
  valueLabel: e,
  dimensionKey: (r == null ? void 0 : r.key) ?? E.key,
  dimensionLabel: (r == null ? void 0 : r.label) ?? E.label
});
function mt(e) {
  const r = Object.keys(e).filter(
    (t) => !qe.shape.hasOwnProperty(t)
  ).reduce((t, a) => [
    ...t,
    {
      attributeKey: a,
      attributeLabel: a,
      value: e[a],
      valueLabel: `${e[a]}`
      // Centra doesn't support value labels for attributes , so we cant have in algolia either
    }
  ], []).filter((t) => t.value !== void 0), i = `product-${e.product}`;
  return [
    ...r,
    {
      attributeKey: D,
      attributeLabel: D,
      value: i,
      valueLabel: i
    }
  ];
}
const Ot = (e, r, i, t) => ({
  id: r,
  name: r,
  selected: t.includes(`${e}:${r}`),
  disabled: !1,
  count: i
});
export {
  D as ALGOLIA_OBJECT_ID_ATTRIBUTE_KEY,
  ot as AlgoliaAutoCompleteClient,
  Dt as AlgoliaAutoCompleteProvider,
  ve as AlgoliaNotifications,
  it as AlgoliaProvider,
  $e as AlgoliaRecommendations,
  It as AlgoliaSearchResultsProvider,
  x as DEFAULT_DELIMITER,
  te as algoliaCentraShopApiItemToGreasePurchaseInfo,
  qe as algoliaCentraShopApiProductSchema,
  Ft as algoliaCentraShopApiProductToGreaseProduct,
  L as algoliaCentraShopApiProductToGreaseProductBase,
  at as algoliaCentraShopApiProductToGreaseProductContent,
  st as algoliaCentraShopApiProductToGreaseProductMediaImages,
  ut as algoliaCentraShopApiProductToGreaseProductVariant,
  J as algoliaCentraShopProductTypeSchema,
  W as algoliaClientDataContext,
  z as algoliaConfigContext,
  Be as algoliaFacetsToGreaseFacets,
  xe as algoliaRecommendationQuerySchema,
  Ne as algoliaSearchPayloadSchema,
  Ve as algoliaSearchProviderSchema,
  Je as algoliaSearchResponseToGreaseSearchResult,
  We as decomposeCompositeData,
  ze as decomposeCompositeFacets,
  Ot as defaultAlgoliaFacetToGreaseFacetValue,
  Ct as emptyArraySchema,
  X as generateFacetGroupCombinations,
  et as generateFacetGroupFilters,
  _ as getAlgoliaObjectId,
  mt as getExtraAttributesForProduct,
  nt as getProductCategories,
  lt as getProductPrice,
  ct as getStockByMarket,
  dt as getVariantDimensions,
  Me as initializeIndividualFacets,
  T as isAlgoliaCentraShopApiProduct,
  H as parseCompositeValue,
  Xe as performDisjunctiveSearch,
  Ke as processCompositeSelections,
  Qe as processIndividualSelections,
  ee as searchResultFacetsToAlgoliaFacetFilters,
  Fe as shopProductBundleInfoSchema,
  De as shopProductBundleProductSchema,
  U as shopProductBundleQuantitySchema,
  Ee as shopProductBundleSchema,
  ke as shopProductCategorySchema,
  Oe as shopProductItemSchema,
  we as shopProductLowestPriceSchema,
  Ce as shopProductMarketPricelistSchema,
  Ie as shopProductMarketSchema,
  je as shopProductSchema,
  q as shopProductStockAmountSchema,
  v as useAlgoliaConfig,
  Te as useAlgoliaFetchRecommendations,
  F as useAlgoliaFetchSearchResult,
  tt as useAlgoliaLoadPage,
  Et as useAlgoliaReset,
  Z as useAlgoliaSearch,
  R as useAlgoliaSearchClientDataGetter,
  Se as useAlgoliaSendInsights,
  rt as useAlgoliaSetFacets
};
//# sourceMappingURL=lib.es.js.map
